import Vue from 'vue'
import * as types from '../mutation-types'
import helpers from '@/util/helpers'

// initial state
const state = {
  storyPublicationRule: {}
}

// getters
const getters = {
  storyPublicationRule: state => state.storyPublicationRule
}

// actions
const actions = {
  createStoryPublicationRule ({ state, commit }, args) {
    return Vue.axios.post(
      `/stories/${args.story_id}/publication-rules/`,
      args
    ).then((response) => {
      commit(types.RECEIVE_STORY_PUBLICATION_RULE, { response })
    })
  },
  deleteStoryPublicationRule ({ state, commit }, args) {
    return Vue.axios.delete(`/stories/${args.story_id}/publication-rules/${args.rule_id}/`, {
        headers: args.headers || null
    }).then((response) => {
      if (response.data.results.publication_rules) {
        commit(types.RECEIVE_STORY_PUBLICATION_RULE, { response })
      }
    })
  }
}

// mutations
const mutations = {
  [types.RECEIVE_STORY_PUBLICATION_RULE] (state, { response }) {
    state.storyPublicationRule = response.data.results
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
